import styles from './CmsHelpSearch.module.scss';
import SearchForm from '../../../SearchForm';
import Container from '../../../Container';
import React from 'react';
import { Content, Heading, getHeadingTag } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const CmsHelpSearch = ({
  headingLevel = 2,
  activeFilter,
  filters,
  placeholder,
  subtitle,
  theme = 'default',
  title,
}) => (
  <Container className={styles.container} size="lg">
    {!!title && (
      <Heading
        as={getHeadingTag(headingLevel)}
        className={styles.title}
        size="h1"
        theme={theme}
      >
        {title}
      </Heading>
    )}
    {!!subtitle && (
      <Content size="lg" theme={theme}>
        {subtitle}
      </Content>
    )}
    <SearchForm
      filters={filters}
      placeholder={placeholder}
      selectedFilterId={activeFilter}
    />
  </Container>
);

CmsHelpSearch.propTypes = {
  activeFilter: PropTypes.string,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  headingLevel: PropTypes.number,
  placeholder: PropTypes.string,
  subtitle: PropTypes.string,
  theme: PropTypes.oneOf(['default', 'contrast']),
  title: PropTypes.string,
};

export default CmsHelpSearch;
